import React from 'react'
import { Link } from 'react-router-dom'
import { Container } from './components/Container'

interface Props {
  title: string
  link: string
  image: string
}

export const CategoryTile: React.FC<Props> = ({ title, link, image }) => {
  return (
    <Container>
      <Link to={link}>
        <div
          className='image'
          style={{
            backgroundImage: `url(${image})`
          }}
        />
        <div className='content'>
          <div className='title'>
            {title}
          </div>
        </div>
      </Link>
    </Container>
  )
}
